import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from 'vuex-module-decorators'

export interface ModalCollectionEditStoreInterface {
  collectionId: number
  bibliographyRealId: number
  onUpdateClosed?: () => Promise<void>
}

@Module({
  name: 'ModalCollectionEditStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalCollectionEditStore extends BaseStore {
  _isOpen: boolean = false

  _collectionId: number = 0

  _bibliographyRealId: number = 0

  _updateClosedCallback?: () => Promise<void>

  _isUpdated: boolean = false

  get isOpen(): boolean {
    return this._isOpen
  }

  get collectionId(): number {
    return this._collectionId
  }

  get bibliographyRealId(): number {
    return this._bibliographyRealId
  }

  @Mutation
  public open(params: ModalCollectionEditStoreInterface) {
    this._isOpen = true
    this._collectionId = params.collectionId ?? 0
    this._bibliographyRealId = params.bibliographyRealId ?? 0
    this._updateClosedCallback = params.onUpdateClosed
    this._isUpdated = false
  }

  @Mutation
  public onUpdate(): void {
    this._isUpdated = true
  }

  @Mutation
  public close(): void {
    this._isOpen = false

    if (this._isUpdated && this._updateClosedCallback !== undefined) {
      this._updateClosedCallback()
    }
  }
}
